define.alias("shared/components/shared/user/info", "auth/components/shared/user/info");